<template>
  <div>
    <Paid v-if="flowState==='paid'" :lesson="lesson"></Paid>
    <NotPaid v-if="flowState==='not-paid'" :lesson="lesson"></NotPaid>
    <Scheduled v-if="flowState==='scheduling'"></Scheduled>
  </div>
</template>

<script>
  import axios from 'axios'
  import env from '@/enviroment';
  import lStorage from '@/store/localStorage';
  import store from '@/store';
  import Paid from './Paid';
  import NotPaid from './NotPaid';
  import Scheduled from './Scheduled';

  export default {
    name: "Full",
    components: {
      Paid,
      NotPaid,
      Scheduled
    },
    data: function () {
      return {
        loaded: false,
        flowState: '',
        lesson: {}
      }
    },
    computed: {

    },
    mounted() {
      this.getFullLesson();
    },
    methods: {
      getFullLesson() {
        this.loaded = false;
        store.commit('loading/is', true);
        axios.get(env.URL + '/wp-json/sahapi/v1/full_flow', {
          headers: {
            'Authorization': 'Bearer ' + lStorage.get('auth-token'),
          },
        })
          .then((response) => {
            let data = response.data;
            if (data) {
              this.flowState = data.flow_state;
              this.lesson = data.lesson;
            }
            store.commit('loading/is', false);
            this.loaded = true;
          })
          .catch((error) => {
            this.loaded = true;
            store.commit('loading/is', false);
          });
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
